var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgColetaDeProduto = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M18.866 77.112h8.65L61.633 66V53.25c0-2.083-.883-10.5-11.074-10.926H25.203c-8.12 0-14.703 6.582-14.703 14.702v11.72a8.366 8.366 0 0 0 8.366 8.366Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M21 65.25V58.5h.75l3 5.25 3.75 3h-6l-1.5-1.5Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M18 74.25h8.25l.751 3h-7.5l-3.75-.75-3.75-3-1.5-3.75V60l1.5-9.75 4.5-5.25 2.25-.75c-2.25 1.5-5.825 4.92-6 9.75-.082 2.248 0 11.25 0 14.25s1.5 6 5.25 6Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M27.516 77.112h-8.65a8.366 8.366 0 0 1-8.366-8.366v-11.72c0-8.12 6.583-14.702 14.703-14.702H43.5M61.633 66V53.25c0-2.083-.883-7.5-6.133-9.75"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M27.711 66.398h-5.042a1.68 1.68 0 0 1-1.68-1.68v-6.16"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.402 36.349c-7.969 0-14.425-6.455-14.425-14.424 0-7.968 6.456-14.425 14.425-14.425 7.968 0 14.423 6.46 14.423 14.424 0 7.963-6.458 14.423-14.423 14.423v.002Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.4 36.349c-7.968 0-14.424-6.455-14.424-14.424C24.976 13.957 31.432 7.5 39.4 7.5c7.968 0 14.423 6.46 14.423 14.424 0 7.963-6.458 14.423-14.423 14.423v.002Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "m53.25 21-28.5 1.5.75-3.75h27.75V21Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.4 36.349c-7.968 0-14.424-6.455-14.424-14.424C24.976 13.957 31.432 7.5 39.4 7.5c7.968 0 14.423 6.46 14.423 14.424 0 7.963-6.458 14.423-14.423 14.423v.002Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.4 7.5c-7.047 0-12.913 5.051-14.174 11.732h28.347C52.313 12.554 46.45 7.5 39.401 7.5Z"
  }), React.createElement("path", {
    fill: color,
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.4 7.5c-7.047 0-12.913 5.051-14.174 11.732H58.73c2.771 0 2.771-3.482-.229-3.482h-6c-3-5.25-6.768-8.25-13.1-8.25Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M68.814 67.657v11.537l-19.165 9.978-20.364-9.978v-11.42"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M68.814 67.657v11.537l-19.165 9.978-20.364-9.978v-11.42M49.648 65.473V89.17"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "m68.814 56.742 5.39 8.108-17.967 9.355-6.589-8.732"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m68.814 56.742 5.39 8.108-17.967 9.355-6.589-8.732"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m68.25 56.25-9.75-3-11.25 8.25 5.25 3 15.75-8.25Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m58.499 53.25 10.314 3.493M29.285 56.743 39.75 52.5"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M37.5 71.25c.16-2.306-2.052-2.646-3.75-3.75-.664-.43 1.5-1.5 0-3s-6.663 1.357-6.75 3l-.338 7.624c-.088 1.63.573 2.283 3.005 2.533 3.332.343 7.597-.775 7.832-4.157v-2.25Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M37.5 72c-.98 1.624-1.499 2.25-2.999 3s-5.41.626-6.75 0c-1.5-1.5-1.001-2.838-1.089-1.195v1.32c-.087 1.63.574 2.282 3.005 2.532C33 78 37.265 76.882 37.5 73.5V72Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M37.5 71.25c.16-2.306-2.052-2.646-3.75-3.75-.664-.43 1.5-1.5 0-3s-6.663 1.357-6.75 3l-.338 7.624c-.088 1.63.573 2.283 3.005 2.533 3.332.343 7.597-.775 7.832-4.157v-2.25Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M64.22 71.102c.103 3.216 2.676 4.96 5.5 5.607 1.605.368 3.131-.864 3.055-2.51l-.33-7.06c-.077-1.633-1.69-2.716-3.252-2.22-2.722.866-5.08 2.79-4.972 6.183Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M64.501 72.75c0 1.5 3.84 4.47 6 3.75 2.25-.75 2.35-.656 2.274-2.3V72c-.077-1.635-.713 1.753-2.274 2.25-2.722.865-6-2.307-6-1.5Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M64.22 71.102c.103 3.216 2.676 4.96 5.5 5.607 1.605.368 3.131-.864 3.055-2.51l-.33-7.06c-.077-1.633-1.69-2.716-3.252-2.22-2.722.866-5.08 2.79-4.972 6.183Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "m49.648 65.473-5.99 9.355-20.363-9.978 5.99-8.108"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m49.648 65.473-5.99 9.355-20.363-9.978 5.99-8.108"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m29.285 56.742 20.363 8.731 19.166-8.73"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m29.285 56.742 20.363 8.731 19.166-8.73"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m42.299 51.178 6.071 6.8c.62.696 1.638.696 2.26 0l6.071-6.8c.643-.719.18-1.935-.736-1.935h-3.371c-.058 0-.103-.051-.103-.114v-7.36c0-.701-.516-1.269-1.152-1.269h-3.678c-.636 0-1.151.568-1.151 1.27v7.358c0 .063-.046.114-.103.114h-3.372c-.916 0-1.379 1.217-.736 1.936v0Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M67.645 30.98c0 10.155 9.54 18.665 9.54 18.665s9.54-8.51 9.54-18.665a9.54 9.54 0 0 0-9.54-9.54c-5.27 0-9.54 4.272-9.54 9.54Zm13.167 0a3.627 3.627 0 1 1-7.253 0 3.627 3.627 0 0 1 7.253 0Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: borderColor,
    d: "m77.185 49.645-.499.56a.75.75 0 0 0 .999 0l-.5-.56Zm0 0 .5-.56-.005-.004a2.078 2.078 0 0 1-.092-.084 30.6 30.6 0 0 1-1.346-1.353 36.949 36.949 0 0 1-3.213-3.955c-2.348-3.343-4.634-7.856-4.634-12.71h-1.5c0 5.302 2.484 10.122 4.906 13.572a38.455 38.455 0 0 0 3.346 4.117 32.1 32.1 0 0 0 1.421 1.428l.085.079.023.02.007.007.002.001c0 .001.001.001.5-.558Zm8.79-18.665c0 4.853-2.286 9.366-4.633 12.71a36.949 36.949 0 0 1-3.214 3.954 30.6 30.6 0 0 1-1.346 1.353 8.16 8.16 0 0 1-.074.068l-.018.016-.004.003v.001l.5.56.499.559.003-.002.006-.006.023-.021a12.716 12.716 0 0 0 .4-.377 32.1 32.1 0 0 0 1.107-1.13 38.466 38.466 0 0 0 3.345-4.117c2.423-3.45 4.907-8.27 4.907-13.571h-1.5Zm-8.79-8.79a8.79 8.79 0 0 1 8.79 8.79h1.5c0-5.684-4.606-10.29-10.29-10.29v1.5Zm-8.79 8.79a8.79 8.79 0 0 1 8.79-8.79v-1.5c-5.684 0-10.29 4.608-10.29 10.29h1.5Zm8.79 4.376a4.377 4.377 0 0 0 4.377-4.377h-1.5a2.877 2.877 0 0 1-2.877 2.877v1.5ZM72.81 30.98a4.377 4.377 0 0 0 4.376 4.377v-1.5a2.877 2.877 0 0 1-2.876-2.877h-1.5Zm4.376-4.377a4.377 4.377 0 0 0-4.376 4.377h1.5a2.877 2.877 0 0 1 2.876-2.877v-1.5Zm4.377 4.377a4.377 4.377 0 0 0-4.377-4.377v1.5a2.877 2.877 0 0 1 2.877 2.877h1.5Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M78 49.501S67.645 41.135 67.645 30.98c0-5.268 2.835-9.229 8.105-9.229 6 0-4.5 0-5.25 8.25 0 10.155 7.5 19.5 7.5 19.5Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M77.185 34.606a3.627 3.627 0 1 0 0-7.254 3.627 3.627 0 0 0 0 7.254Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M77.185 49.645s-9.54-8.51-9.54-18.665c0-5.268 4.27-9.54 9.54-9.54a9.54 9.54 0 0 1 9.54 9.54c0 10.155-9.54 18.665-9.54 18.665Z"
  }));
};
export default SvgColetaDeProduto;